"use client";

import CareersPage from "@/components/careers/CareersPage";
import Container from "@/components/common/Container";
import { MarketingCareersHero } from "@/components/redesign/MarketingCareersHero";
import { isJobType, type JobType } from "@/utils/jobsPublic";
import { usePathname } from "next/navigation";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

function loadingFilterFromPathname(pathname: string): JobType | "all" {
  const lastSegment = pathname.split("/").findLast(Boolean);
  return lastSegment && isJobType(lastSegment) ? lastSegment : "all";
}

export default function CareersLoadingPage() {
  const { t } = useTranslation();
  const pathname = usePathname();

  // Next.js skips its scroll-to-top when a navigation streams in through a
  // loading boundary, leaving visitors at their previous scroll position
  // (e.g. arriving from a footer link). Restore the default behavior here.
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Container headerVariant="redesign">
      <MarketingCareersHero
        title={t("redesign.careers.heroTitle")}
        subtitle={t("careers.heroSubtitle")}
      />
      <CareersPage
        jobs={[]}
        initialFilter={loadingFilterFromPathname(pathname)}
        isLoading
      />
    </Container>
  );
}
